module.exports = __webpack_public_path__ + "static/media/6.a289ff90.jpg";